import { useEffect, useState } from 'react';
import styles from './sponsor.module.css'
import SponsorOverlay from '../../overlays/sponsor/sponsor-overlay';
import Waves from './waves'
import planeImg from '../../assets/gfx/plane.svg'
import { useInViewHysteresis } from '../../hooks/in-view';
import { useAnimationControls, motion } from 'framer-motion';
import CheckMoreButton from '../../components/check-more/check-more';


function SponsorSlide({lang}) {
    const [isOverlayOpen, _setOverlayOpen] = useState(false);
    const {ref, inView} = useInViewHysteresis({ threshold: [] }, { enter: 0.8, exit: 0, once: false, resetOnExit: true });
    const controls = useAnimationControls();

    useEffect(() => {
        if (inView) {
            controls.start("fly");
        } else {
            controls.stop();
            controls.set("ready");
        }
    }, [inView, controls]);

    function setOverlayOpen(b) {
        if (b) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        _setOverlayOpen(b);
    }

    return (
        <>
            <div id="sponsor" ref={ref} className={styles.wrapper}>   
                <div className={styles.content}>
                    <div className={styles['content-title']}>SPONSOR</div>
                    <div className={styles['content-subtitle']}>スポンサー</div>
                </div>
                <div className={styles['more']}>
                    <CheckMoreButton onClick={() => setOverlayOpen(true)} />
                </div>
                <motion.img 
                    src={planeImg}
                    className={styles.plane}
                    alt="plane"
                    variants={{
                        ready: {x: "-100%", y: "2rem", rotate: "180deg"},
                        fly: {
                            x: "100vw",
                            rotate: "180deg",
                            transition: {
                                duration: 3,
                                ease: "linear"
                            }
                        }
                    }}
                    initial="ready"
                    animate={controls}
                />
                <Waves />
            </div>
            { isOverlayOpen && <SponsorOverlay lang={lang} close={() => {setOverlayOpen(false)}} /> }
        </>
    )
}

export default SponsorSlide
